import React, { useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import {
  StyledMenuItem,
  StyledSelect,
  StyledDropDownIcon,
} from "./LanguageSelect.styled";
import Tooltip from "@material-ui/core/Tooltip";
import { changeLanguage } from "../../state/theme/theme.action";
import { getLanguage } from "../../state/theme/theme.selector";

const LanguageSelect = (props) => {
  const [isOpenTooltip, setIsOpenToolTip] = useState(false);
  const language = useSelector(getLanguage);
  const dispatch = useDispatch();
  const handleChange = (e) => {
    dispatch(changeLanguage(e.target.value));
  };
  return (
    <Tooltip open={isOpenTooltip} title="Change language">
      <StyledSelect
        value={language}
        onChange={handleChange}
        IconComponent={StyledDropDownIcon}
        onMouseEnter={() => setIsOpenToolTip(true)}
        onMouseLeave={() => setIsOpenToolTip(false)}
      >
        <StyledMenuItem value={"en"} onMouseEnter={() => setIsOpenToolTip(false)}>EN</StyledMenuItem>
        <StyledMenuItem value={"vn"} onMouseEnter={() => setIsOpenToolTip(false)}>VN</StyledMenuItem>
      </StyledSelect>
    </Tooltip>
  );
};


export default LanguageSelect;
